import { render } from "./TextoModeloInput.vue?vue&type=template&id=1c394522&scoped=true&ts=true"
import script from "./TextoModeloInput.vue?vue&type=script&lang=ts"
export * from "./TextoModeloInput.vue?vue&type=script&lang=ts"

import "./TextoModeloInput.vue?vue&type=style&index=0&id=1c394522&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c394522"]])

export default __exports__